import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ShimmerElementType } from './interfaces';

@Component({
  selector: 'vi-ui-shimmer',
  templateUrl: './shimmer.component.html',
  styleUrls: ['./shimmer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShimmerComponent implements OnInit {
  @Input() elementType: ShimmerElementType;
  @Input() numOfElements: number;
  @Input() forceFullWidth: boolean = false;

  // relevant only for ShimmerElementType.CUSTOM
  @Input() height: number;
  @Input() width: number;

  public elements: number[];

  public ShimmerElementType = ShimmerElementType;

  public ngOnInit() {
    this.elements = new Array(this.numOfElements);
  }
}
